module.exports = __webpack_public_path__ + "static/media/Morph1.09f93a4a.png";